<ng-container *appTranslate="let t">
  <new-ui-dashboard-card>
    <ng-template #header>
      <new-ui-dashboard-card-header
        [title]="
          ankaadiaUpdate()
            ? t('dashboard.releaseNotes.title') + ' (' + (ankaadiaUpdate().date | appDate) + ')'
            : t('dashboard.releaseNotes.title')
        "
      >
        @if (isLicensed()) {
          <new-ui-button
            [label]="t('dashboard.releaseNotes.roadmap')"
            icon="icon-[mi--share-arrow-square-1]"
            severity="secondary"
            (click)="openRoadmap()"
          />
        }
      </new-ui-dashboard-card-header>
    </ng-template>

    @defer (when ankaadiaUpdate()) {
      @if (ankaadiaUpdate().image) {
        <a
          href="https://docs2.ankaadia.com/release-notes/release-{{ ankaadiaUpdate().tagName }}"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div
            class="h-full p-6 rounded-large flex justify-center items-center"
            style="background: radial-gradient(60.57% 91.16% at 46.25% 22.76%, #378874 0%, #ffedd4 100%)"
          >
            <img [src]="ankaadiaUpdate().image" class="shadow-xl rounded-large max-h-full max-w-full" />
          </div>
        </a>
      }
    } @placeholder {
      <div class="col gap-4">
        <p-skeleton class="h-40 w-full rounded-large" />
        <p-skeleton class="h-6 w-3/4" />
        <p-skeleton class="h-4 w-full" />
        <p-skeleton class="h-4 w-5/6" />
        <p-skeleton class="h-4 w-4/6" />
      </div>
    }
  </new-ui-dashboard-card>
</ng-container>
